import React, { Component } from "react";
import style from "./PracticeComplience.module.css";
import {
  Button,
} from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import PermitsUpload from "../PermitsUpload/PermitsUpload";
//import DatePicker from "react-datepicker";
import { DatePicker } from "antd";
import { fetchDropdownList, fetchMedSchemes } from "../../redux";
import { fetchPracticeList, fetchDisciplineList, fetchPricegroupsList } from "../../redux";
import api from "../../utils/Api";
import moment from "moment";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Select } from "antd";
import swal from "sweetalert";
import AddPracticeLogo from "./AddPracticeLogo/AddPracticeLogo";
import { checkValidData } from "../../utils/CommonUtil";
import { NAME_MESSAGE, NAME_REGEX } from "../../utils/RegexConstants";
const { Option } = Select;

function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
    }`;
}

export class PracticeComplience extends Component {
  constructor(props) {
    super(props);

    this.state = {
      registration_name: "",
      registration_date: "",
      discipline_code: "",
      billing_practise_pcns_number: "",
      cms_registration_number: "",
      cms_doctor_type_number: "",
      dispensing_doctor_license_number: "",
      vat_registration_number: "",
      isBillingPractitioner: 0,
      billing_practice_registration_name: "",
      billing_practice_registration_date: "",
      billing_practice_discipline_code: "",
      billing_practice_billing_practise_pcns_number: "",
      billing_practice_cms_registration_number: "",
      billing_practice_cms_doctor_type_number: "",
      billing_practice_dispensing_doctor_license_number: "",
      billing_practice_vat_registration_number: "",
      activeTab: "1",
      shareHolderinputList: [
        {
          name: "",
          surname: "",
          hpcsa_number: "",
          address: "",
          contact_number: "",
          isNewUpload: true,
          delete: false,
        },
      ],
      billingPolicyConfiguration: [],
      medicalAidContractArray: [],
      medicalAidContractSelectedArray: [],
      inputList: [],
      schemes: [],
      pricegroups: [],
      uploadLogo: [],
      editLogo: [],
      error: "",
      isValid: false,
      successMessage: "",
      errorMessage: "",
      isLoading: false,
      isScreenLoaded: false,
      dateError: "",
      isUploadError: false,
      firstConsultationConfiguration:[]
    };
  }

  componentDidMount = async () => {
    document.title = 'Practice Compliance - TechToMedix';
    await this.props.fetchPracticeList();
    this.props.fetchDisciplineList();
    if (!this.props.fetchPracticeListData.loading &&
      this.props.fetchPracticeListData.practiceList &&
      (this.props.fetchPracticeListData.practiceList.practise || this.props.fetchPracticeListData.practiceList.billingPracticeDetails)) {
      // const shareHolderinputListData = this.state.shareHolderinputList.map(
      //   (item) => ({
      //     isNewUpload: item.isNewUpload,
      //     delete: item.delete,
      //   })
      // );
      this.setState({
        isBillingPractitioner: 
        this.props.fetchPracticeListData.practiceList.isBillingPractitioner === 1 ? 1: 0,
        registration_name:
          this.props.fetchPracticeListData.practiceList.practise &&
          this.props.fetchPracticeListData.practiceList.practise
            .registration_name,
        registration_date:
          this.props.fetchPracticeListData.practiceList.practise &&
          this.props.fetchPracticeListData.practiceList.practise
            .registration_date,
        discipline_code:
          this.props.fetchPracticeListData.practiceList.practise &&
          this.props.fetchPracticeListData.practiceList.practise.discipline_code ? 
          this.props.fetchPracticeListData.practiceList.practise.discipline_code :(
            this.props.fetchPracticeListData.practiceList.billingPracticeDetails &&
          this.props.fetchPracticeListData.practiceList.billingPracticeDetails.discipline_code ),
        billing_practise_pcns_number:
          this.props.fetchPracticeListData.practiceList.practise &&
          this.props.fetchPracticeListData.practiceList.practise.billing_practise_pcns_number,
        cms_registration_number:
          this.props.fetchPracticeListData.practiceList.practise &&
          this.props.fetchPracticeListData.practiceList.practise.cms_registration_number,
        cms_doctor_type_number:
          this.props.fetchPracticeListData.practiceList.practise &&
          this.props.fetchPracticeListData.practiceList.practise.cms_doctor_type_number,
        dispensing_doctor_license_number:
          this.props.fetchPracticeListData.practiceList.practise &&
            this.props.fetchPracticeListData.practiceList.practise.dispensing_doctor_license_number ?
            this.props.fetchPracticeListData.practiceList.practise.dispensing_doctor_license_number : "",
        vat_registration_number:
          this.props.fetchPracticeListData.practiceList.practise &&
            this.props.fetchPracticeListData.practiceList.practise.vat_registration_number ?
            this.props.fetchPracticeListData.practiceList.practise.vat_registration_number : "",
        shareHolderinputList:
          this.props.fetchPracticeListData.practiceList &&
          this.props.fetchPracticeListData.practiceList.practiseShareholder,
        inputList:
          this.props.fetchPracticeListData.practiceList &&
          this.props.fetchPracticeListData.practiceList.practiseDocuments,
        medicalAidContractSelectedArray:
          this.props.fetchPracticeListData.practiceList &&
            this.props.fetchPracticeListData.practiceList.contracts ?
            this.props.fetchPracticeListData.practiceList.contracts : [],

            
        billing_practice_registration_name:
        this.props.fetchPracticeListData.practiceList.billingPracticeDetails &&
        this.props.fetchPracticeListData.practiceList.billingPracticeDetails
          .registration_name,
        billing_practice_registration_date:
        this.props.fetchPracticeListData.practiceList.billingPracticeDetails &&
        this.props.fetchPracticeListData.practiceList.billingPracticeDetails
          .registration_date,
        billing_practice_discipline_code:
        this.props.fetchPracticeListData.practiceList.billingPracticeDetails &&
        this.props.fetchPracticeListData.practiceList.billingPracticeDetails.discipline_code,
        billing_practice_billing_practise_pcns_number:
        this.props.fetchPracticeListData.practiceList.billingPracticeDetails &&
        this.props.fetchPracticeListData.practiceList.billingPracticeDetails.billing_practise_pcns_number,
        billing_practice_cms_registration_number:
        this.props.fetchPracticeListData.practiceList.billingPracticeDetails &&
        this.props.fetchPracticeListData.practiceList.billingPracticeDetails.cms_registration_number,
        billing_practice_cms_doctor_type_number:
        this.props.fetchPracticeListData.practiceList.billingPracticeDetails &&
        this.props.fetchPracticeListData.practiceList.billingPracticeDetails.cms_doctor_type_number,
        billing_practice_dispensing_doctor_license_number:
        this.props.fetchPracticeListData.practiceList.billingPracticeDetails &&
          this.props.fetchPracticeListData.practiceList.billingPracticeDetails.dispensing_doctor_license_number ?
          this.props.fetchPracticeListData.practiceList.billingPracticeDetails.dispensing_doctor_license_number : "",
        billing_practice_vat_registration_number:
        this.props.fetchPracticeListData.practiceList.billingPracticeDetails &&
          this.props.fetchPracticeListData.practiceList.billingPracticeDetails.vat_registration_number ?
          this.props.fetchPracticeListData.practiceList.billingPracticeDetails.vat_registration_number : "",
        billingPolicyConfiguration: 
        this.props.fetchPracticeListData.practiceList.billingPolicyConfiguration,
        editLogo: 
        this.props.fetchPracticeListData.practiceList.practice_logo ? this.props.fetchPracticeListData.practiceList.practice_logo : [],
        firstConsultationConfiguration: 
        (this.props.fetchPracticeListData.practiceList.firstConsultationConfiguration)||[],
      },()=>{
       this.updateContracts();
      });
    }
    setTimeout(() => {
      this.setState({
        isScreenLoaded: true,
      });
    }, 500);
  };


  updateContracts = async() => {
    
    if (this.state.isBillingPractitioner === 1 && this.state.discipline_code) {
      await this.props.fetchPricegroupsList(this.state.discipline_code);
    }else if(this.state.isBillingPractitioner === 0 && this.state.billing_practice_discipline_code){
      await this.props.fetchPricegroupsList(this.state.billing_practice_discipline_code);
    }
    let medicalAidContractSelectedArray = [...this.state.medicalAidContractSelectedArray];
   //console.log("medicalAidContractSelectedArray",medicalAidContractSelectedArray)
    let pricegroupsArr = [];
    if (medicalAidContractSelectedArray && medicalAidContractSelectedArray.length > 0) {
      medicalAidContractSelectedArray.forEach((selectedScheme, index) => {
        medicalAidContractSelectedArray[index].price_checked = 1;
        pricegroupsArr.push(medicalAidContractSelectedArray[index].price_group_code);
      })
     // console.log("pricegroupsArr", pricegroupsArr)
    }

    this.setState({
      medicalAidContractArray: medicalAidContractSelectedArray,
      pricegroups: pricegroupsArr
    },()=>{
    this.updateBillingPolicy();
    });
    
  }

  updateBillingPolicy = () => {

    const dropdownListData = this.props.dropdownListData.dropdownList;
  

    let billingPolicyConfiguration = this.state.billingPolicyConfiguration ? [...this.state.billingPolicyConfiguration]: [];

    if(billingPolicyConfiguration.length === 0){
    
      dropdownListData && dropdownListData.billing_policy && dropdownListData.billing_policy.forEach((item)=>{
        billingPolicyConfiguration.push({
          billing_policy_configuration_id: "",
          percentage: 100,
          billing_policy_id:item.billing_policy_id,
          billing_policy_name: item.billing_policy,
          discipline_code: this.state.billing_practice_discipline_code
        })
      })

    }else{
      let newBillingConfig = []
      dropdownListData && dropdownListData.billing_policy && dropdownListData.billing_policy.forEach((item)=>{
        const billingPolicyObj =  billingPolicyConfiguration && billingPolicyConfiguration.find((elem)=>(
          elem.billing_policy_id === item.billing_policy_id
        ));
        if(billingPolicyObj){
          newBillingConfig.push({
            billing_policy_configuration_id: billingPolicyObj.billing_policy_configuration_id,
            percentage: billingPolicyObj.percentage,
            billing_policy_id: item.billing_policy_id,
            billing_policy_name: item.billing_policy,
            discipline_code: billingPolicyObj.discipline_code ? billingPolicyObj.discipline_code : this.state.billing_practice_discipline_code
          }) 
      }else{
        newBillingConfig.push({
          billing_policy_configuration_id: "",
          percentage: 100,
          billing_policy_id: item.billing_policy_id,
          billing_policy_name: item.billing_policy,
          discipline_code: this.state.discipline_code
        }) 
      }
      })
      billingPolicyConfiguration = [...newBillingConfig];
      // billingPolicyConfiguration && billingPolicyConfiguration.forEach((item)=>{
      //   const billingPolicyObj =  dropdownListData && dropdownListData.billing_policy && dropdownListData.billing_policy.find((elem)=>(
      //     elem.billing_policy_id === item.billing_policy_id
      //   ));
      //   if(billingPolicyObj){
      //     item.billing_policy_name = billingPolicyObj.billing_policy
      //   }
      // })
      
    }
    //console.log("billingPolicyConfiguration", billingPolicyConfiguration)

    this.setState({
      billingPolicyConfiguration: billingPolicyConfiguration
    })
  }


  getDisciplineName = (discipline_code) => {
    if(!discipline_code){
      return "Not Available";
    }
    const practiceTypeList = this.props.disciplineListData.disciplineList;

    let practiceObj = practiceTypeList && practiceTypeList.find((item)=>(
      item.code === discipline_code
    ))

    return practiceObj && practiceObj.description ? practiceObj.description : "Not Available"

  }

  getDoctorTypeNumber = (doctorTypeNumber) => {
    if(!doctorTypeNumber){
      return "Not Available";
    }
    const doctorTypeList =  this.props.dropdownListData.dropdownList && 
    this.props.dropdownListData.dropdownList.lk_cms_doctor_type;

    let Obj = doctorTypeList && doctorTypeList.find((item)=>(
      item.code === doctorTypeNumber
    ))

    return Obj && Obj.cms_doctor_type ? Obj.cms_doctor_type : "Not Available"
  }

  // handleInputDeselectSelectSchemes = (data) => {
  //   console.log("data", data);

  // }

  // handleInputSelectSchemes = (arr) => {
  //   console.log("arr", arr);
  //   let schemes = [...this.state.schemes];

  //   // this.setState({
  //   //   schemes: arr,
  //   // });
  //   let medicalAidContractArray = [...this.state.medicalAidContractArray];

  //   let schemesData = this.props.schemesData.schemes;

  //   let schemeExist = medicalAidContractArray.length > 0 && medicalAidContractArray.findIndex((item)=>(
  //     item.scheme_code === arr && item.delete !== true
  //     ))

  //     if(typeof schemeExist === "number" && schemeExist > -1){
  //       if(medicalAidContractArray.length>0){
  //         medicalAidContractArray[schemeExist].delete = true;
  //         medicalAidContractArray[schemeExist].scheme_checked = 0;
  //         if(medicalAidContractArray[schemeExist].newAdded){
  //           medicalAidContractArray.splice(schemeExist, 1);
  //         }

  //       }
  //       if(schemes.length > 0 && schemes.indexOf(arr) > -1){
  //         let index = schemes.indexOf(arr) ;
  //         schemes.splice(index, 1);
  //       }
  //     }else {
  //      let newScheme = schemesData.length > 0 && schemesData.find((scheme)=>(
  //         scheme.code === arr
  //       ))
  //       medicalAidContractArray.push({
  //                 scheme_checked: 1,
  //                 scheme_name: newScheme.name,
  //                 scheme_code: newScheme.code,
  //               //  price_group_code: "",
  //                 lk_contract_type_id: "",
  //                 lk_rule_type_id: "",
  //                 contract_type: "",
  //                 subcategory_id: "",
  //                 subcategory: "",
  //                 datefrom: "",
  //                 dateto: "",
  //                 newAdded: true
  //       })
  //       schemes.push(arr);
  //     }

  //     console.log("medicalAidContractArray", medicalAidContractArray)

  //     this.setState({
  //       medicalAidContractArray: medicalAidContractArray,
  //       schemes: schemes
  //     })

  // };




  handleInputSelectPriceGroups = (arr) => {
   // console.log("arr", arr);
    let pricegroups = [...this.state.pricegroups];

    let medicalAidContractArray = [...this.state.medicalAidContractArray];

    let pricegroupsListData = this.props.pricegroupsListData &&
      this.props.pricegroupsListData.pricegroupsList &&
      this.props.pricegroupsListData.pricegroupsList.TariffPriceGroups &&
      this.props.pricegroupsListData.pricegroupsList.TariffPriceGroups.PageResult;

    let schemeExist = medicalAidContractArray.length > 0 && medicalAidContractArray.findIndex((item) => (
      item.price_group_code === arr && item.delete !== true
    ))

    if (typeof schemeExist === "number" && schemeExist > -1) {
      if (medicalAidContractArray.length > 0) {
        medicalAidContractArray[schemeExist].delete = true;
        medicalAidContractArray[schemeExist].price_checked = 0;
        if (medicalAidContractArray[schemeExist].newAdded) {
          medicalAidContractArray.splice(schemeExist, 1);
        }

      }
      if (pricegroups.length > 0 && pricegroups.indexOf(arr) > -1) {
        let index = pricegroups.indexOf(arr);
        pricegroups.splice(index, 1);
      }
    } else {
      let newPricegroup = pricegroupsListData.length > 0 && pricegroupsListData.find((item) => (
        item.code === arr
      ))
      medicalAidContractArray.push({
        price_checked: 1,
        price_group_code_description: newPricegroup.description,
        price_group_code: newPricegroup.code,
        lk_contract_type_id: null,
        lk_rule_type_id: null,
        contract_type: "",
        subcategory_id: null,
        subcategory: "",
        datefrom: "",
        dateto: "",
        newAdded: true
      })
      pricegroups.push(arr);
    }

   // console.log("medicalAidContractArray", medicalAidContractArray)

    this.setState({
      medicalAidContractArray: medicalAidContractArray,
      pricegroups: pricegroups
    })

  };


  handleInputSelectSpecialistsPriceGroups = (arr, flag) => {
   // console.log("arr", arr);
    let pricegroups = [...this.state.pricegroups];

    let medicalAidContractArray = [...this.state.medicalAidContractArray];

    let pricegroupsListData = this.props.pricegroupsListData &&
      this.props.pricegroupsListData.pricegroupsList &&
      this.props.pricegroupsListData.pricegroupsList.TariffPriceGroups &&
      this.props.pricegroupsListData.pricegroupsList.TariffPriceGroups.PageResult;

    // let schemeExist = medicalAidContractArray.length > 0 && medicalAidContractArray.findIndex((item) => (
    //   item.price_group_code === arr && item.delete !== true
    // ))

    // if (typeof schemeExist === "number" && schemeExist > -1) {
    //   if (medicalAidContractArray.length > 0) {
    //     medicalAidContractArray[schemeExist].delete = true;
    //     medicalAidContractArray[schemeExist].price_checked = 0;
    //     if (medicalAidContractArray[schemeExist].newAdded) {
    //       medicalAidContractArray.splice(schemeExist, 1);
    //     }

    //   }
    //   if (pricegroups.length > 0 && pricegroups.indexOf(arr) > -1) {
    //     let index = pricegroups.indexOf(arr);
    //     pricegroups.splice(index, 1);
    //   }
    // } else {
      let newPricegroup = pricegroupsListData.length > 0 && pricegroupsListData.find((item) => (
        item.code === arr
      ));
      medicalAidContractArray.push({
        price_checked: 1,
        price_group_code_description: newPricegroup.description,
        price_group_code: newPricegroup.code,
        lk_contract_type_id: null,
        lk_rule_type_id: null,
        contract_type: "",
        subcategory_id: null,
        subcategory: "",
        datefrom: "",
        dateto: "",
        newAdded: true
      });
     // pricegroups.push(arr);
    //}

   // console.log("medicalAidContractArray", medicalAidContractArray)

    this.setState({
      medicalAidContractArray: medicalAidContractArray,
      pricegroups: pricegroups,
      searchPriceGoup: null
    })

  };

  getImageError = (data) => {
    console.log("Is Image Error : ", data);
    this.setState({
      isUploadError: data,
    });
  };

  handleChangeDate = (date) => {
    this.setState({
      registration_date: date,
    });
  };

  // common diagnosis handlechange
  inputChange = (event) => {
    const val = event.target.value;
    const name = event.target.name;
    this.setState({
      [name]: val,
    });
  };


  onChangePracticeType = async (value) => {

    if(this.state.isBillingPractitioner === 1){
      let medicalAidContractArray = [...this.state.medicalAidContractArray];
      let filteredArray = medicalAidContractArray.length > 0 && medicalAidContractArray.filter((item) => (
      item.delete !== true
    ))
    if (filteredArray && filteredArray.length > 0) {
      const confirmFlag = await swal("Changing practice type will remove all of your selected contracts. Do you want to proceed?", {
        className: "logout-swal-modal",
        buttons: ["Cancel", "Yes"],
      });
      if (confirmFlag) {
        medicalAidContractArray.forEach((item) => {
          item.delete = true;
        })
        this.setState({
          pricegroups: [],
          medicalAidContractArray: medicalAidContractArray,
        })
      } else {
        return false;
      }
    }
    }
    
    this.setState({
      discipline_code: value,
    }, async () => {
      if(this.state.isBillingPractitioner === 1){
        await this.props.fetchPricegroupsList(this.state.discipline_code);
      }
    });
  };

  handleInputCheckBoxChange = (event, index) => {
    event.persist();
    const val = event.target.checked;
    const name = event.target.name;
    let medicalAidContractArray = [...this.state.medicalAidContractArray];
    let pricegroups = [...this.state.pricegroups];
    if (medicalAidContractArray.length > 0) {

      medicalAidContractArray[index].price_checked = val ? 1 : 0;
      medicalAidContractArray[index].delete = !(val);

      if (pricegroups.length > 0 && pricegroups.indexOf(medicalAidContractArray[index].price_group_code) > -1) {
        let schemeIndex = pricegroups.indexOf(medicalAidContractArray[index].price_group_code);
        pricegroups.splice(schemeIndex, 1);
      }
      if (medicalAidContractArray[index].newAdded) {
        medicalAidContractArray.splice(index, 1);
      }
    }
    this.setState(
      {
        medicalAidContractArray: medicalAidContractArray,
        pricegroups: pricegroups
      });

  };

  handleMedicalContractInputChange = (event, index) => {
    const val = event.target.value;
    const name = event.target.name;
    const label = event.target.options[event.target.selectedIndex].text;
    const list = [...this.state.medicalAidContractArray];
    list[index][name] = val;
    if (name === "lk_contract_type_id") {
      list[index].contract_type = label;
    } else if (name === "subcategory_id") {
      list[index].subcategory = label;
    }
    this.setState({
      medicalAidContractArray: list,
    });
  };

  handleMedicalContractInputDateChange = (date, name, index) => {
    const list = [...this.state.medicalAidContractArray];
    list[index][name] = date;
    this.setState({
      medicalAidContractArray: list,
    });
  }

  handlePriceInputDateChange = (date, name, index) => {
    const list = [...this.state.firstConsultationConfiguration];
    list[index][name] = date;
    this.setState({
      firstConsultationConfiguration: list,
    });
  }

  handleInputChange = (event, index) => {
    const val = event.target.value;
    const name = event.target.name;
    this.setState({
      [name]: val,
    });
    const list = [...this.state.shareHolderinputList];
    list[index][name] = val;
    this.setState({
      shareHolderinputList: list,
    });
  };

  handlePercentInputChange = (event, index) => {
    const val = event.target.value;
    const name = event.target.name;
    this.setState({
      [name]: val,
    });
    const list = [...this.state.billingPolicyConfiguration];
    list[index][name] = val;
    this.setState({
      billingPolicyConfiguration: list,
    });
  };

  handleConsultationPriceInputChange = (event, index) => {
    const val = event.target.value;
    const name = event.target.name;
    this.setState({
      [name]: val,
    });
    const list = [...this.state.firstConsultationConfiguration];
    list[index][name] = val;
    this.setState({
      firstConsultationConfiguration: list,
    });
  };


  handleRemoveClick = (index) => {
    const list = [...this.state.shareHolderinputList];

    if (list[index].isNewUpload) {
      list.splice(index, 1);
    } else {
      list[index].delete = true;
    }

    this.setState({
      shareHolderinputList: list,
    });
  };

  handleAddClick = () => {
    this.setState((prevState) => ({
      shareHolderinputList: [
        ...this.state.shareHolderinputList,
        {
          name: "",
          surname: "",
          hpcsa_number: "",
          address: "",
          contact_number: "",
          isNewUpload: true,
          delete: false
        },
      ],
    }));

  };

  handleFirstConsultationAddClick = () => {
    this.setState((prevState) => ({
      firstConsultationConfiguration: [
        ...this.state.firstConsultationConfiguration,
        {
          consultation_price:"",
          datefrom:"",
          dateto:""
        },
      ],
    }));

  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  getPermitsProof = (data) => {
   // console.log("Payment Proof : ", data);
    this.setState({
      inputList: data,
    });
  };

    // Getting picture data
    getLogoData = (logoData) => {
      this.setState({
        uploadLogo: logoData,
      });
    };

  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no notification to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
  }
  // Post practice complience data
  // onSubmit = async () => {};

  render() {
    //const schemesData = this.props.schemesData && this.props.schemesData.schemes;
    const pricegroupsListData = this.props.pricegroupsListData &&
      this.props.pricegroupsListData.pricegroupsList &&
      this.props.pricegroupsListData.pricegroupsList.TariffPriceGroups &&
      this.props.pricegroupsListData.pricegroupsList.TariffPriceGroups.PageResult;

    const practiceTypeList = this.props.disciplineListData.disciplineList;
    const doctorTypeList = this.props.dropdownListData.dropdownList.lk_cms_doctor_type;
    const ruleTypeList = this.props.dropdownListData.dropdownList &&
      this.props.dropdownListData.dropdownList.lk_rule_type;
    const contractTypeList = this.props.dropdownListData.dropdownList &&
      this.props.dropdownListData.dropdownList.lk_contract_type;
    // getting practcie type dropdwon options data
    const practiceTypeOptionsData =
      practiceTypeList &&
      practiceTypeList.map((element, index) => (
        <option key={index} value={element.code}>
          {element.description}
        </option>
      ));

    const doctorTypeOptionsData =
      doctorTypeList &&
      doctorTypeList.map((element, index) => (
        <option key={index} value={element.code}>
          {element.cms_doctor_type}
        </option>
      ))


    if (!this.state.isScreenLoaded) {
      return (
        <div className="dashboard-loader">
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
    return (
      <Formik
        initialValues={this.state}
        enableReinitialize={true}
        validationSchema={Yup.object().shape({
          registration_name: Yup.string()
            .required("Registration Name is required")
            .matches(NAME_REGEX, NAME_MESSAGE)
            .nullable(),
          // registration_number: Yup.string()
          //   .required("Registration Number is required")
          //   .matches(/^[0-9]*$/, "Only numbers are allowed")
          //   .nullable(),
          // registration_date: Yup.date()
          //   .required("Registration Date is required")
          //   .nullable(),
          registration_date: Yup.date()
            .required("Registration Date is required")
            .nullable(),
          // practice_type: Yup.string()
          //   .required("Practice Type is required")
          //   .nullable(),
          discipline_code: Yup.string()
            .required("Practice Type is required")
            .nullable(),
          billing_practise_pcns_number: Yup.string()
            .required("PCNS number is required")
            .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumeric values allowed")
            .nullable(),
          cms_registration_number: Yup.string()
            .required("CMS Registration number is required")
            .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumeric values allowed")
            .nullable(),
          cms_doctor_type_number: Yup.string()
            .required("CMS Doctor Type is required")
            .nullable(),
          dispensing_doctor_license_number: Yup.string()
            .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumeric values allowed")
            .nullable(),
          vat_registration_number: Yup.string()
            .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumeric values allowed")
            .nullable(),
          shareHolderinputList: Yup.array().of(
            Yup.object().shape({
              name: Yup.string()
                .required("Name is required")
                .matches(NAME_REGEX, NAME_MESSAGE).nullable(),
              surname: Yup.string()
                .required("Surname is required")
                .matches(NAME_REGEX, NAME_MESSAGE).nullable(),
              hpcsa_number: Yup.string()
                .required("HPCSA number is required")
                .matches(/^[0-9]*$/, "Only numbers allowed")
                .nullable(),
              address: Yup.string().required("Address is required"),
              contact_number: Yup.string()
                .required("Contact number is required")
                .matches(/^[0-9+]*$/, "Only numbers and + allowed")
                .matches(/^[0-9+]{10,15}$/, "Enter 10 to 15 characters"),
            })
          ),
          billingPolicyConfiguration:Yup.array().of(
            Yup.object().shape({
              percentage: Yup.string().when("billing_policy_id", {
                is: (value) => this.state.isBillingPractitioner === 1,
                then: Yup.string()
                .matches(/^[0-9]\d{0,9}(\.\d{1,2})?%?$/, "Only numbers allowed")
                  .required("Percentage is required!"),
                otherwise: Yup.string().nullable(),
              }).nullable(),
            })
          ),
          medicalAidContractArray: Yup.array().of(
            Yup.object().shape({
              lk_contract_type_id: Yup.string().when(["price_checked", "delete"], {
                is: (value, value2) => value === 1 && value2 !== true && this.state.isBillingPractitioner === 1 && this.state.discipline_code === "014",
                then: Yup.string()
                  .required("Contract Type is required"),
                otherwise: Yup.string().nullable(),
              }).nullable(),
              lk_rule_type_id: Yup.string().when(["price_checked", "delete"], {
                is: (value, value2) => value === 1 && value2 !== true && this.state.isBillingPractitioner === 1 && this.state.discipline_code !== "014",
                then: Yup.string()
                  .required("Rule Type is required"),
                otherwise: Yup.string().nullable(),
              }).nullable(),
              subcategory_id: Yup.string().when(["price_checked", "delete"], {
                is: (value, value2) => value === 1 && value2 !== true && this.state.isBillingPractitioner === 1 && this.state.discipline_code === "014",
                then: Yup.string()
                  .required("Subcategory is required"),
                otherwise: Yup.string().nullable(),
              }).nullable(),
              datefrom: Yup.string().when("price_checked", {
                is: (value) => value === 1,
                then: Yup.string()
                  .required("Date From is required"),
                otherwise: Yup.string().nullable(),
              }).nullable(),
              dateto: Yup.string().when("price_checked", {
                is: (value) => value === 1,
                then: Yup.string()
                  .required("Date To is required"),
                otherwise: Yup.string().nullable(),
              }).nullable(),
            })
          ),
        })}
        onSubmit={async (data) => {
            this.setState({
                    errorMessage: "",
                  });
          // alert("SUCCESS!! :-)\n\n" + JSON.stringify(data, null, 4));

          this.setState({
            isLoading: true,
          });

          if (
            this.state.registration_date === "" ||
            this.state.registration_date === null
          ) {
            this.setState({
              dateError: "Registration Date is required",
            });
          } else {
            this.setState({
              dateError: "",
            });
          }
          if (this.state.dateError === "" && !this.state.isUploadError) {
            const formData = new FormData();
            formData.append("registration_name", data.registration_name);
            //formData.append("registration_number", data.registration_number);
            formData.append(
              "registration_date",
              moment(data.registration_date).format("YYYY-MM-DD")
            );

            // formData.append("lk_practise_type_id", data.practice_type);
            formData.append("discipline_code", data.discipline_code);
            formData.append("billing_practise_pcns_number", data.billing_practise_pcns_number);
            formData.append("cms_registration_number", data.cms_registration_number);
            formData.append("cms_doctor_type_number", data.cms_doctor_type_number);
            if (data.dispensing_doctor_license_number) {
              formData.append("dispensing_doctor_license_number", data.dispensing_doctor_license_number);
            }
            if (data.vat_registration_number) {
              formData.append("vat_registration_number", data.vat_registration_number);
            }


            formData.append(
              "practiseShareholder",
              JSON.stringify(data.shareHolderinputList)
            );

            const attachmentData = [];
            data.inputList.map((element, index) => {
              if (element.isNewUpload && element.selectedFile) {
                formData.append("attachment", element.selectedFile);
                formData.append("document_type", element.document_type? element.document_type : null);
                formData.append("description", element.description? element.description: null);
              } else if (element.attachment_id) {
                attachmentData.push({
                  attachment_id: element.attachment_id,
                  file_path: element.file_path,
                  file_name: element.file_name,
                  description: element.description,
                  document_type: element.document_type,
                  delete: element.delete,
                });
              }
            });
            formData.append("attachmentData", JSON.stringify(attachmentData));
            
            
            if(this.state.isBillingPractitioner === 1){
              const practiceLogoData = [];
              data.uploadLogo.forEach((element, index) => {
                if (element.isNewUpload && element.selectedFile) {
                  formData.append("practice_logo", element.selectedFile);
                } 
                // else if (element.attachment_id) {
                //   practiceLogoData.push({
                //     attachment_id: element.attachment_id,
                //     delete: element.delete,
                //   });
                // }
              });
             // formData.append("practice_logo", JSON.stringify(practiceLogoData));


              const medicalAidContractData = [];
              data.medicalAidContractArray.forEach((element, index) => {
                if (element.price_checked === 1 || (element.price_checked === 0 && element.delete === true)) {
                  element.datefrom = dateFormatter(element.datefrom);
                  element.dateto = dateFormatter(element.dateto);
                  medicalAidContractData.push(element);
                }
              });

              // console.log("medicalAidContractData", medicalAidContractData);

              formData.append("contracts", JSON.stringify(medicalAidContractData));

              formData.append("billingPolicyConfiguration", JSON.stringify(data.billingPolicyConfiguration));
              formData.append("firstConsultationConfiguration", JSON.stringify(data.firstConsultationConfiguration));

            }

            // Headers
            const headers = {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
            };
            try {
              const response = await api.post(
                "practise/complaince/save",
                formData,
                {
                  headers: headers,
                }
              );
              
            
              let contracts = response && response.data && response.data.data && 
              response.data.data.contractData ? response.data.data.contractData : [];
              
              let billingPolicyConfiguration = response && response.data && response.data.data && 
              response.data.data.billingPolicyConfiguration ? response.data.data.billingPolicyConfiguration : [];
              

              if (response.status === 200) {
                this.setState({
                  isLoading: false,
                  successMessage: "Practice compliance saved successfully!",
                });

                setTimeout(() => {
                  this.setState({
                    successMessage: "",
                  });
                }, 2000);
                if(this.state.isBillingPractitioner === 1){
                  this.setState({
                    medicalAidContractSelectedArray : contracts,
                    billingPolicyConfiguration:billingPolicyConfiguration
                  },()=>{
                    this.updateContracts();
                  })
                }
              }
            } catch (error) {
              if (error.response) {
                this.setState({
                  isLoading: false,
                  errorMessage: error.response.data &&
                  error.response.data.message ? error.response.data.message :"Something went wrong! Please try again later",
                });
                // setTimeout(() => {
                //   this.setState({
                //     errorMessage: "",
                //   });
                // }, 10000);
              }
            }
          }
        }}
      >
        {({ errors, status, touched }) => (
          <Form>
            <div className={style.practiceComMainWrapper}>
              <div className="row">
                <div className="col-md-12">
                  <h3>Practice Compliance</h3>
                </div>
                <div className="col-md-12 intro-text">
                  <p class="mb-4">
                  Practice Compliance provides a single site where all the regulatory, 
                  legal and compliance details of the practice may be stored. 
                  It also caters for the capture of all contracts signed between the practice and medical aid providers.
                  </p>
                </div>
              </div>
              <div>
                {this.props.loading ? (
                  <div className={style.loadingWrapper}>
                    <img src={ttmLoader} alt="loader" className={style.loading} />
                  </div>
                ) : (
                    <div>


{this.state.isBillingPractitioner === 0 && (
                  <div className="row">
                    <div className="col-md-12">
                      <h6>Billing Practice Details :</h6>
                      <div className={style.rPartyDetailsWrapper}>
                        <div className="row">
                          <div className="col-md-6">
                            <label>Registration Name </label>: {checkValidData(this.state.billing_practice_registration_name)}
                          </div>
                          <div className="col-md-6">
                            <label>Registration Date</label>:{" "}
                            {dateFormatter(this.state.billing_practice_registration_date)}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <label>Practice Type </label>:{" "}
                            {this.getDisciplineName(this.state.billing_practice_discipline_code)}
                          </div>
                          <div className="col-md-6">
                            <label>Billing Practice PCNS No. </label>:{" "}
                            {checkValidData(this.state.billing_practice_billing_practise_pcns_number)}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <label>CMS Registration No. </label>:{" "}
                            {checkValidData(this.state.billing_practice_cms_registration_number)}
                          </div>
                          <div className="col-md-6">
                            <label>CMS Doctor Type </label>:{" "}
                            {this.getDoctorTypeNumber(this.state.billing_practice_cms_doctor_type_number)}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <label>Dispensing Doctor License No.</label>:{" "}
                            {checkValidData(this.state.billing_practice_dispensing_doctor_license_number)}
                          </div>
                          <div className="col-md-6">
                            <label>VAT Registration No.</label>:{" "}
                            {checkValidData(this.state.billing_practice_vat_registration_number)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}



                      <div className="form-box-shadow">
                        <div className="row">
                          <div className="col-lg-12">
                            <h4>Practice Info :</h4>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 col-lg-4 col-xl-3">
                            <div className="form-group">
                              <label htmlFor="registration_name">
                                Registered Name{" "}
                                <span className="mandatory">
                                  <small>*</small>
                                </span>
                              </label>
                              <Field
                                name="registration_name"
                                type="text"
                                placeholder="Registered Name"
                                onChange={this.inputChange}
                                value={this.state.registration_name}
                                maxLength="30"
                                className={
                                  "form-control" +
                                  (errors.registration_name &&
                                    touched.registration_name
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                              <ErrorMessage
                                name="registration_name"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>

                          <div className="col-md-6 col-lg-4 col-xl-3">
                            <div className="form-group">
                              <label htmlFor="registration_date">
                                Registration Date{" "}
                                <span className="mandatory">
                                  <small>*</small>
                                </span>
                              </label>
                              <DatePicker
                                selected={
                                  this.state.registration_date
                                    ? new Date(this.state.registration_date)
                                    : null
                                }
                                onChange={this.handleChangeDate}
                                name="registration_date"
                                dateFormat="yyyy-MM-dd"
                                className={`form-control ${errors && errors.registration_date
                                    ? "is-invalid"
                                    : ""
                                  }`}
                                defaultValue={
                                  this.state.registration_date
                                    ? moment(this.state.registration_date)
                                    : ""
                                }
                              />
                              {errors && errors.registration_date && (
                                <span className={`error ${style.dateErrorText}`}>
                                  Registration Date is required
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6 col-lg-4 col-xl-3">
                            <div className="form-group">
                              <label htmlFor="discipline_code">
                                Practice Type{" "}
                                <span className="mandatory">
                                  <small>*</small>
                                </span>
                              </label>
                              {/* <Field
                                as="select"
                                name="discipline_code"
                                onChange={this.inputChange}
                                className={
                                  "form-control" +
                                  (errors.discipline_code && touched.discipline_code
                                    ? " is-invalid"
                                    : "")
                                }
                              >
                                <option value="">Select practice type</option>
                                {practiceTypeOptionsData}
                              </Field> */}
                              <Select
                                showSearch
                                allowClear={true}
                                name="discipline_code"
                                placeholder="Search practice type"
                                optionFilterProp="children"
                                onChange={this.onChangePracticeType}
                                className={
                                  (errors.discipline_code && touched.discipline_code
                                    ? " is-invalid"
                                    : "")
                                }
                                filterOption={(input, option) =>
                                  option.children.toString()
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                value={this.state.discipline_code || undefined}
                              >
                                {practiceTypeList &&
                                  practiceTypeList.map((element, index) => (
                                    <Option key={index} value={element.code}>
                                      {element.description}
                                    </Option>
                                  ))}
                              </Select>
                              <ErrorMessage
                                name="discipline_code"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>

                          <div className="col-md-6 col-lg-4 col-xl-3">
                            <div className="form-group">
                              <label htmlFor="billing_practise_pcns_number">
                                Practitioner PCNS No.{" "}
                                <span className="mandatory">
                                  <small>*</small>
                                </span>
                              </label>
                              <Field
                                name="billing_practise_pcns_number"
                                type="text"
                                placeholder="PCNS Number"
                                onChange={this.inputChange}
                                maxLength="18"
                                className={
                                  "form-control" +
                                  (errors.billing_practise_pcns_number &&
                                    touched.billing_practise_pcns_number
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                              <ErrorMessage
                                name="billing_practise_pcns_number"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>

                          <div className="col-md-6 col-lg-4 col-xl-3">
                            <div className="form-group">
                              <label htmlFor="cms_registration_number">
                                CMS Registration Number{" "}
                                <span className="mandatory">
                                  <small>*</small>
                                </span>
                              </label>
                              <Field
                                name="cms_registration_number"
                                type="text"
                                placeholder="CMS Registration Number"
                                onChange={this.inputChange}
                                maxLength="20"
                                className={
                                  "form-control" +
                                  (errors.cms_registration_number &&
                                    touched.cms_registration_number
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                              <ErrorMessage
                                name="cms_registration_number"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>

                          <div className="col-md-6 col-lg-4 col-xl-3">
                            <div className="form-group">
                              <label htmlFor="cms_doctor_type_number">
                                CMS Doctor Type Number{" "}
                                <span className="mandatory">
                                  <small>*</small>
                                </span>
                              </label>
                              <Field
                                as="select"
                                name="cms_doctor_type_number"
                                placeholder="CMS Doctor Type Number"
                                onChange={this.inputChange}
                                maxLength="25"
                                className={
                                  "form-control" +
                                  (errors.cms_doctor_type_number &&
                                    touched.cms_doctor_type_number
                                    ? " is-invalid"
                                    : "")
                                }
                              >
                                <option value="">Select CMS doctor type</option>
                                {doctorTypeOptionsData}
                              </Field>
                              <ErrorMessage
                                name="cms_doctor_type_number"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>


                          <div className="col-md-6 col-lg-4 col-xl-3">
                            <div className="form-group">
                              <label htmlFor="dispensing_doctor_license_number">
                                Dispensing Doctor License No.
                              {/* <span className="mandatory">
                                <small>*</small>
                              </span> */}
                              </label>
                              <Field
                                name="dispensing_doctor_license_number"
                                type="text"
                                placeholder="Dispensing Doctor License No."
                                onChange={this.inputChange}
                                maxLength="20"
                                className={
                                  "form-control" +
                                  (errors.dispensing_doctor_license_number &&
                                    touched.dispensing_doctor_license_number
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                              <ErrorMessage
                                name="dispensing_doctor_license_number"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>

                          <div className="col-md-6 col-lg-4 col-xl-3">
                            <div className="form-group">
                              <label htmlFor="vat_registration_number">
                                VAT Registration Number{" "}
                                {/* <span className="mandatory">
                                <small>*</small>
                              </span> */}
                              </label>
                              <Field
                                name="vat_registration_number"
                                type="text"
                                placeholder="VAT Registration Number"
                                onChange={this.inputChange}
                                maxLength="15"
                                className={
                                  "form-control" +
                                  (errors.vat_registration_number &&
                                    touched.vat_registration_number
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                              <ErrorMessage
                                name="vat_registration_number"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>

                        </div>
                      </div>

                      <div className={`form-box-shadow mt-4 ${style.medicalAidContractSection}`}>
                        <div className="row">
                          <div className="col-lg-12">
                            <h4>Medical Aid Contract Info :</h4>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-12">
                            {(this.state.isBillingPractitioner === 1 && this.state.discipline_code === "014") &&(
                            <div className="form-group">
                              <label htmlFor="pricegroups">
                                Search and Select your contracts from the below box :</label>
                              <Select
                                mode="multiple"
                                style={{ width: '100%' }}
                                name="pricegroups"
                                filterOption={(input, option) =>
                                  option.children.toString()
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                onSelect={this.handleInputSelectPriceGroups}
                                disabled={this.state.isBillingPractitioner !== 1}
                                onDeselect={this.handleInputSelectPriceGroups}
                                placeholder="Search or Select contracts here..."
                                value={this.state.pricegroups}
                              >
                                {pricegroupsListData && pricegroupsListData.length > 0 && pricegroupsListData.map((element, index) => (
                                  <Option key={index} value={element.code}>
                                    {element.description} - {element.code}
                                  </Option>
                                ))}
                              </Select>
                              <ErrorMessage
                                name="pricegroups"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>)}
                            {(this.state.isBillingPractitioner === 1 && this.state.discipline_code !== "014") && (
                            <div className="form-group">
                              <label htmlFor="searchPriceGoup">
                                Search and Select your contracts from the below box :</label>
                              <Select
                                //mode="multiple"
                                showSearch
                                allowClear={true}
                                style={{ width: '100%' }}
                                name="searchPriceGoup"
                                filterOption={(input, option) =>
                                  option.children.toString()
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                autoClearSearchValue={true}
                                onSelect={(val)=>this.handleInputSelectSpecialistsPriceGroups(val)}
                                disabled={this.state.isBillingPractitioner !== 1}
                               //onDeselect={(val)=>this.handleInputSelectSpecialistsPriceGroups(val)}
                                placeholder="Search or Select contracts here..."
                                //value={this.state.pricegroups}
                                value={ this.state.searchPriceGoup}
                              >
                                {pricegroupsListData && pricegroupsListData.length > 0 && pricegroupsListData.map((element, index) => (
                                  <Option key={index} value={element.code}>
                                    {element.description} - {element.code}
                                  </Option>
                                ))}
                              </Select>
                              <ErrorMessage
                                name="searchPriceGoup"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>)}
                          </div>
                          <div className="col-lg-12">
                            <div className={`table-responsive ${style.tableFixHead}`}>
                              <table className="table practice-comp-table">
                                <thead id="header">
                                  <tr>
                                    <th width="3%"></th>
                                    <th>
                                      Contract
                                    </th>
                                    {/* <th>
                                      Price Group
                                      <span className="mandatory">
                                        <small>*</small>
                                      </span>
                                    </th> */}
                                    {((this.state.isBillingPractitioner === 1 && this.state.discipline_code === "014") ||
                                               (this.state.isBillingPractitioner === 0 && this.state.billing_practice_discipline_code === "014")) && (
                                      <th>
                                        Contract Type
                                        <span className="mandatory">
                                          <small>*</small>
                                        </span>
                                      </th>
                                    )}

                                    {((this.state.isBillingPractitioner === 1 && this.state.discipline_code === "014") ||
                                       (this.state.isBillingPractitioner === 0 && this.state.billing_practice_discipline_code === "014")) && (
                                      <th>
                                        Subcategory
                                        <span className="mandatory">
                                          <small>*</small>
                                        </span>
                                      </th>)}
                                    {((this.state.isBillingPractitioner === 1 && this.state.discipline_code !== "014") ||
                                    (this.state.isBillingPractitioner === 0 && this.state.billing_practice_discipline_code !== "014")) && (
                                      <th>
                                        Rule Type
                                        <span className="mandatory">
                                          <small>*</small>
                                        </span>
                                      </th>)}
                                    <th>
                                      Date From
                                      <span className="mandatory">
                                        <small>*</small>
                                      </span>
                                    </th>
                                    <th>
                                      Date To
                                      <span className="mandatory">
                                        <small>*</small>
                                      </span>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>

                                  {this.state.medicalAidContractArray &&
                                    this.state.medicalAidContractArray.map(
                                      (element, i) => {
                                        return (
                                          !element.delete &&
                                          (<React.Fragment key={i}>
                                            <tr key={i}>
                                              <td width="3%">
                                                <div
                                                  className={`custom-control custom-checkbox ${style.recurringWrapper}`}
                                                >
                                                  {this.state.isBillingPractitioner === 1 && (
                                                    <React.Fragment>
                                                    <input
                                                      type="checkbox"
                                                      className="custom-control-input"
                                                      id={element.price_group_code}
                                                      name={element.price_group_code}
                                                      disabled={this.state.isBillingPractitioner !== 1}
                                                      onChange={(e) =>
                                                        this.handleInputCheckBoxChange(
                                                          e,
                                                          i
                                                        )
                                                      }
                                                      checked={element.price_checked === 1}
                                                    />
                                                    <label
                                                      className="custom-control-label"
                                                      htmlFor={element.price_group_code}
                                                    >
                                                    </label>
                                                    </React.Fragment>
                                                  )}
                                                </div>
                                              </td>
                                              <td>
                                                <div className="form-group">
                                                  <label>{element.price_group_code_description}</label>
                                                </div>
                                              </td>
                                              {((this.state.isBillingPractitioner === 1 && this.state.discipline_code === "014") ||
                                               (this.state.isBillingPractitioner === 0 && this.state.billing_practice_discipline_code === "014")) && (
                                                <td>
                                                  <div className="form-group">
                                                    <Field
                                                      as="select"
                                                      name="lk_contract_type_id"
                                                      placeholder="Contract Type"
                                                      maxLength="20"
                                                      disabled={element.price_checked === 0 || this.state.isBillingPractitioner !== 1}
                                                      onChange={(e) =>
                                                        this.handleMedicalContractInputChange(
                                                          e,
                                                          i
                                                        )
                                                      }
                                                      className={
                                                        "form-control" +
                                                        (errors && errors.medicalAidContractArray &&
                                                          errors
                                                            .medicalAidContractArray[
                                                          i
                                                          ] &&
                                                          errors
                                                            .medicalAidContractArray[i]
                                                            .lk_contract_type_id && touched &&
                                                          touched.medicalAidContractArray &&
                                                          touched
                                                            .medicalAidContractArray[
                                                          i
                                                          ] &&
                                                          touched
                                                            .medicalAidContractArray[i]
                                                            .lk_contract_type_id
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                      value={
                                                        element.lk_contract_type_id
                                                      }
                                                    >
                                                      <option value="">Select contract type</option>
                                                      {contractTypeList && contractTypeList.map((item, index) => (
                                                        <option key={index} value={item.lk_contract_type_id}>{item.contract_type}</option>
                                                      ))}
                                                    </Field>

                                                    <ErrorMessage
                                                      name={`medicalAidContractArray[${i}].lk_contract_type_id`}
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                </td>
                                              )}

                                              {((this.state.isBillingPractitioner === 1 && this.state.discipline_code === "014") ||
                                               (this.state.isBillingPractitioner === 0 && this.state.billing_practice_discipline_code === "014"))&& (
                                                <td>
                                                  <div className="form-group">
                                                    <Field
                                                      as="select"
                                                      name="subcategory_id"
                                                      placeholder="Subcategory"
                                                      maxLength="20"
                                                      disabled={element.price_checked === 0 || this.state.isBillingPractitioner !== 1}
                                                      onChange={(e) =>
                                                        this.handleMedicalContractInputChange(
                                                          e,
                                                          i
                                                        )
                                                      }
                                                      className={
                                                        "form-control" +
                                                        (errors && errors.medicalAidContractArray &&
                                                          errors
                                                            .medicalAidContractArray[
                                                          i
                                                          ] &&
                                                          errors
                                                            .medicalAidContractArray[i]
                                                            .subcategory_id && touched &&
                                                          touched.medicalAidContractArray &&
                                                          touched
                                                            .medicalAidContractArray[
                                                          i
                                                          ] &&
                                                          touched
                                                            .medicalAidContractArray[i]
                                                            .subcategory_id
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                      value={element.subcategory_id}
                                                    >
                                                      <option value="">Select subcategory</option>
                                                      <option value="1">Fixed Price</option>
                                                      <option value="2">Dispensing</option>
                                                      <option value="3">Non-Dispensing</option>
                                                    </Field>

                                                    <ErrorMessage
                                                      name={`medicalAidContractArray[${i}].subcategory_id`}
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                </td>)}
                                              {((this.state.isBillingPractitioner === 1 && this.state.discipline_code !== "014") ||
                                              (this.state.isBillingPractitioner === 0 && this.state.billing_practice_discipline_code !== "014")) && (
                                                <td>
                                                  <div className="form-group">
                                                    <Field
                                                      as="select"
                                                      name="lk_rule_type_id"
                                                      disabled={element.price_checked === 0 || this.state.isBillingPractitioner !== 1}
                                                      onChange={(e) =>
                                                        this.handleMedicalContractInputChange(
                                                          e,
                                                          i
                                                        )
                                                      }
                                                      className={
                                                        "form-control" +
                                                        (errors && errors.medicalAidContractArray &&
                                                          errors
                                                            .medicalAidContractArray[
                                                          i
                                                          ] &&
                                                          errors
                                                            .medicalAidContractArray[i]
                                                            .lk_rule_type_id && touched &&
                                                          touched.medicalAidContractArray &&
                                                          touched
                                                            .medicalAidContractArray[
                                                          i
                                                          ] &&
                                                          touched
                                                            .medicalAidContractArray[i]
                                                            .lk_rule_type_id
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                      value={element.lk_rule_type_id}
                                                    >
                                                      <option value="">Select rule type</option>
                                                      {ruleTypeList && ruleTypeList.map((item, index) => (
                                                        <option key={index} value={item.lk_rule_type_id}>{item.rule_type_label}</option>
                                                      ))}
                                                    </Field>

                                                    <ErrorMessage
                                                      name={`medicalAidContractArray[${i}].lk_rule_type_id`}
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                </td>)}
                                              <td>
                                                <div className="form-group">
                                                  <DatePicker
                                                    selected={
                                                      element.datefrom
                                                        ? new Date(element.datefrom)
                                                        : null
                                                    }
                                                    onChange={(date, dateString) => {
                                                      this.handleMedicalContractInputDateChange(dateString, "datefrom", i);
                                                    }}
                                                    name="datefrom"
                                                    disabled={element.price_checked === 0 || this.state.isBillingPractitioner !== 1}
                                                    disabledDate={(d) => !d || d.isAfter(element.dateTo)}
                                                    dateFormat="yyyy-MM-dd"
                                                    className={"form-control" +
                                                      (errors && errors.medicalAidContractArray &&
                                                        errors
                                                          .medicalAidContractArray[
                                                        i
                                                        ] &&
                                                        errors
                                                          .medicalAidContractArray[i]
                                                          .datefrom && touched &&
                                                        touched.medicalAidContractArray &&
                                                        touched
                                                          .medicalAidContractArray[
                                                        i
                                                        ] &&
                                                        touched
                                                          .medicalAidContractArray[i]
                                                          .datefrom
                                                        ? " is-invalid"
                                                        : "")
                                                    }
                                                    defaultValue={
                                                      element
                                                        .datefrom
                                                        ? moment(element.datefrom)
                                                        : ""
                                                    }
                                                  />
                                                  <ErrorMessage
                                                    name={`medicalAidContractArray[${i}].datefrom`}
                                                    component="div"
                                                    className="invalid-feedback"
                                                  />
                                                </div>
                                              </td>
                                              <td>
                                                <div className="form-group">
                                                  <DatePicker
                                                    selected={
                                                      element.dateto
                                                        ? new Date(element.dateto)
                                                        : null
                                                    }
                                                    onChange={(date, dateString) => {
                                                      this.handleMedicalContractInputDateChange(dateString, "dateto", i);
                                                    }}
                                                    name="dateto"
                                                    disabledDate={(d) => !d || d.isBefore(element.dateFrom)}
                                                    disabled={element.price_checked === 0 || this.state.isBillingPractitioner !== 1}
                                                    dateFormat="yyyy-MM-dd"
                                                    className={"form-control" +
                                                      (errors && errors.medicalAidContractArray &&
                                                        errors
                                                          .medicalAidContractArray[
                                                        i
                                                        ] &&
                                                        errors
                                                          .medicalAidContractArray[i]
                                                          .dateto && touched &&
                                                        touched.medicalAidContractArray &&
                                                        touched
                                                          .medicalAidContractArray[
                                                        i
                                                        ] &&
                                                        touched
                                                          .medicalAidContractArray[i]
                                                          .dateto
                                                        ? " is-invalid"
                                                        : "")
                                                    }
                                                    defaultValue={
                                                      element
                                                        .dateto
                                                        ? moment(element.dateto)
                                                        : ""
                                                    }
                                                  />

                                                  <ErrorMessage
                                                    name={`medicalAidContractArray[${i}].dateto`}
                                                    component="div"
                                                    className="invalid-feedback"
                                                  />
                                                </div>
                                              </td>
                                            </tr>
                                          </React.Fragment>)

                                        );
                                      }
                                    )}
                                </tbody>
                              </table>
                              {this.state.medicalAidContractArray.length === 0 && (
                                <p className="textCenter mt-2">No contracts are selected!</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>


                      <div className="form-box-shadow mt-4">
                        <div className="row">
                          <div className="col-sm-6">
                            <h4>Directors/Shareholders :</h4>
                          </div>
                          <div className="col-sm-6 text-center text-sm-right mb-3 mb-sm-2">
                            <button
                              type="button"
                              onClick={this.handleAddClick}
                              className="ttm-secondary-btn tmed-secondary-btn"
                            >
                              <i
                                className="fa fa-plus mr-2"
                                aria-hidden="true"
                              ></i>
                            Add
                          </button>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-12">
                            <div className="table-responsive">
                              <table className="table practice-comp-table">
                                <thead>
                                  <tr>
                                    <th>
                                      Name{" "}
                                      <span className="mandatory">
                                        <small>*</small>
                                      </span>
                                    </th>
                                    <th>
                                      Surname{" "}
                                      <span className="mandatory">
                                        <small>*</small>
                                      </span>
                                    </th>
                                    <th>
                                      HPCSA Number{" "}
                                      <span className="mandatory">
                                        <small>*</small>
                                      </span>
                                    </th>
                                    <th>
                                      Address{" "}
                                      <span className="mandatory">
                                        <small>*</small>
                                      </span>
                                    </th>
                                    <th>
                                      Contact Number{" "}
                                      <span className="mandatory">
                                        <small>*</small>
                                      </span>
                                    </th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.shareHolderinputList &&
                                    this.state.shareHolderinputList.map(
                                      (x, i) => {
                                        return (
                                          !x.delete && (
                                            <React.Fragment key={i}>
                                              <tr key={i}>
                                                <td>
                                                  <div className="form-group">
                                                    <Field
                                                      type="text"
                                                      name="name"
                                                      placeholder="Name"
                                                      maxLength="20"
                                                      onChange={(e) =>
                                                        this.handleInputChange(
                                                          e,
                                                          i
                                                        )
                                                      }
                                                      className={
                                                        "form-control" +
                                                        (errors.shareHolderinputList &&
                                                          errors
                                                            .shareHolderinputList[
                                                          i
                                                          ] &&
                                                          errors
                                                            .shareHolderinputList[i]
                                                            .name &&
                                                          touched.shareHolderinputList &&
                                                          touched
                                                            .shareHolderinputList[
                                                          i
                                                          ] &&
                                                          touched
                                                            .shareHolderinputList[i]
                                                            .name
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                      value={
                                                        this.state
                                                          .shareHolderinputList[i]
                                                          .name
                                                      }
                                                    />

                                                    <ErrorMessage
                                                      name={`shareHolderinputList[${i}].name`}
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <Field
                                                      type="text"
                                                      name="surname"
                                                      maxLength="20"
                                                      placeholder="Surname"
                                                      onChange={(e) =>
                                                        this.handleInputChange(
                                                          e,
                                                          i
                                                        )
                                                      }
                                                      className={
                                                        "form-control" +
                                                        (errors.shareHolderinputList &&
                                                          errors
                                                            .shareHolderinputList[
                                                          i
                                                          ] &&
                                                          errors
                                                            .shareHolderinputList[i]
                                                            .surname &&
                                                          touched.shareHolderinputList &&
                                                          touched
                                                            .shareHolderinputList[
                                                          i
                                                          ] &&
                                                          errors
                                                            .shareHolderinputList[i]
                                                            .surname
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                      value={
                                                        this.state
                                                          .shareHolderinputList[i]
                                                          .surname
                                                      }
                                                    />

                                                    <ErrorMessage
                                                      name={`shareHolderinputList[${i}].surname`}
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <Field
                                                      type="text"
                                                      name="hpcsa_number"
                                                      maxLength="20"
                                                      placeholder="HPCSA Number"
                                                      onChange={(e) =>
                                                        this.handleInputChange(
                                                          e,
                                                          i
                                                        )
                                                      }
                                                      className={
                                                        "form-control" +
                                                        (errors.shareHolderinputList &&
                                                          errors
                                                            .shareHolderinputList[
                                                          i
                                                          ] &&
                                                          errors
                                                            .shareHolderinputList[i]
                                                            .hpcsa_number &&
                                                          touched.shareHolderinputList &&
                                                          touched
                                                            .shareHolderinputList[
                                                          i
                                                          ] &&
                                                          errors
                                                            .shareHolderinputList[i]
                                                            .hpcsa_number
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                      value={
                                                        this.state
                                                          .shareHolderinputList[i]
                                                          .hpcsa_number
                                                      }
                                                    />

                                                    <ErrorMessage
                                                      name={`shareHolderinputList[${i}].hpcsa_number`}
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <Field
                                                      type="text"
                                                      name="address"
                                                      maxLength="50"
                                                      placeholder="Address"
                                                      onChange={(e) =>
                                                        this.handleInputChange(
                                                          e,
                                                          i
                                                        )
                                                      }
                                                      className={
                                                        "form-control" +
                                                        (errors.shareHolderinputList &&
                                                          errors
                                                            .shareHolderinputList[
                                                          i
                                                          ] &&
                                                          errors
                                                            .shareHolderinputList[i]
                                                            .address &&
                                                          touched.shareHolderinputList &&
                                                          touched
                                                            .shareHolderinputList[
                                                          i
                                                          ] &&
                                                          touched
                                                            .shareHolderinputList[i]
                                                            .address
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                      value={
                                                        this.state
                                                          .shareHolderinputList[i]
                                                          .address
                                                      }
                                                    />

                                                    <ErrorMessage
                                                      name={`shareHolderinputList[${i}].address`}
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                </td>
                                                <td>
                                                  <div className="form-group">
                                                    <Field
                                                      type="text"
                                                      name="contact_number"
                                                      placeholder="Contact Number"
                                                      onChange={(e) =>
                                                        this.handleInputChange(
                                                          e,
                                                          i
                                                        )
                                                      }
                                                      maxLength="10"
                                                      className={
                                                        "form-control" +
                                                        (errors.shareHolderinputList &&
                                                          errors
                                                            .shareHolderinputList[
                                                          i
                                                          ] &&
                                                          errors
                                                            .shareHolderinputList[i]
                                                            .contact_number &&
                                                          touched.shareHolderinputList &&
                                                          touched
                                                            .shareHolderinputList[
                                                          i
                                                          ] &&
                                                          touched
                                                            .shareHolderinputList[i]
                                                            .contact_number
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                      value={
                                                        this.state
                                                          .shareHolderinputList[i]
                                                          .contact_number
                                                      }
                                                    />

                                                    <ErrorMessage
                                                      name={`shareHolderinputList[${i}].contact_number`}
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                </td>
                                                <td>
                                                  {this.state.shareHolderinputList
                                                    .length !== -1 && (
                                                      <i
                                                        className={`fa fa-times ${style.deleteIcon}`}
                                                        aria-hidden="true"
                                                        onClick={(e) =>
                                                          this.handleRemoveClick(i)
                                                        }
                                                      ></i>
                                                    )}
                                                </td>
                                              </tr>
                                            </React.Fragment>
                                          )
                                        );
                                      }
                                    )}

                                  {this.state.shareHolderinputList.length === 0 && (
                                    <p className="textCenter mt-2">No directors / shareHolders are added!</p>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>


                      {/* {this.state.isBillingPractitioner === 1 && ( */}
                      <div className="form-box-shadow mt-4">
                        <div className="row">
                          <div className="col-sm-12">
                            <h4>Billing Policy Configurations :</h4>
                          </div>
                          <div className="col-sm-6 text-center text-sm-right mb-3 mb-sm-2">
                            {/* <button
                              type="button"
                              onClick={this.handleAddClick}
                              className="ttm-secondary-btn tmed-secondary-btn"
                            >
                              <i
                                className="fa fa-plus mr-2"
                                aria-hidden="true"
                              ></i>
                            Add
                          </button> */}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-12">
                            <div className="table-responsive">
                              <table className="table billing-config-table">
                                <thead>
                                  <tr>
                                    <th>
                                      Billing Policy{" "}
                                    </th>
                                    <th>
                                      % Multiplier{" "}
                                      <span className="mandatory">
                                        <small>*</small>
                                      </span>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.billingPolicyConfiguration &&
                                    this.state.billingPolicyConfiguration.map(
                                      (x, i) => {
                                        return (
                                            <React.Fragment key={i}>
                                              <tr key={i}>
                                                <td>
                                                  <div className="form-group">
                                                  <label
                                                    htmlFor={x.billing_policy_name}
                                                  >
                                                    {x.billing_policy_name}
                                                  </label>
                                                  </div>
                                                </td>
                                                <td>
                                                <div className="row">
                                                  <div className="col-md-6">
                                                  <div className="form-group">
                                                    <Field
                                                      type="text"
                                                      name="percentage"
                                                      maxLength="6"
                                                      placeholder="% Multiplier"
                                                      disabled={this.state.isBillingPractitioner !== 1}
                                                      onChange={(e) =>
                                                        this.handlePercentInputChange(
                                                          e,
                                                          i
                                                        )
                                                      }
                                                      className={
                                                        "form-control" +
                                                        (errors.billingPolicyConfiguration &&
                                                          errors
                                                            .billingPolicyConfiguration[
                                                          i
                                                          ] &&
                                                          errors
                                                            .billingPolicyConfiguration[i]
                                                            .percentage &&
                                                          touched.billingPolicyConfiguration &&
                                                          touched
                                                            .billingPolicyConfiguration[
                                                          i
                                                          ] &&
                                                          errors
                                                            .billingPolicyConfiguration[i]
                                                            .percentage
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                      value={
                                                        this.state
                                                          .billingPolicyConfiguration[i]
                                                          .percentage
                                                      }
                                                    />

                                                    <ErrorMessage
                                                      name={`billingPolicyConfiguration[${i}].percentage`}
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                  </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            </React.Fragment>
                                          
                                        );
                                      }
                                    )}

                                  {this.state.billingPolicyConfiguration.length === 0 && (
                                    <p className="textCenter mt-2">No Billing Policy added!</p>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* )} */}
                      {
                        /* First consultation Price settings*/
                      }
                      <div className="form-box-shadow mt-4">
                      <div className="row">
                          <div className="col-sm-6">
                            <h4>First Consultation Configurations:</h4>
                          </div>
                          <div className="col-sm-6 text-center text-sm-right mb-3 mb-sm-2">
                            <button
                              type="button"
                              onClick={this.handleFirstConsultationAddClick}
                              className="ttm-secondary-btn tmed-secondary-btn"
                            >
                              <i
                                className="fa fa-plus mr-2"
                                aria-hidden="true"
                              ></i>
                            Add
                          </button>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="table-responsive">
                              <table className="table billing-config-table">
                                <thead>
                                  <tr>
                                    <th>
                                      Price{" "}
                                      <span className="mandatory">
                                        <small>*</small>
                                      </span>
                                    </th>
                                    <th>
                                      Year{" "}
                                      <span className="mandatory">
                                        <small>*</small>
                                      </span>
                                    </th>
                                  </tr>
                                </thead>
                                
                                <tbody>
                                {this.state.firstConsultationConfiguration &&
                                    this.state.firstConsultationConfiguration.map(
                                      (x, i) => {
                                        return (
                                            <React.Fragment key={i}>
                                              <tr key={i}>
                                                <td>
                                                  <div className="form-group">
                                                  <Field
                                                      type="text"
                                                      name="consultation_price"
                                                      maxLength="6"
                                                      placeholder="Consultation Price"
                                                      disabled={this.state.isBillingPractitioner !== 1}
                                                      onChange={(e) =>
                                                        this.handleConsultationPriceInputChange(
                                                          e,
                                                          i
                                                        )
                                                      }
                                                      className={
                                                        "form-control" +
                                                        (errors.firstConsultationConfiguration &&
                                                          errors
                                                            .firstConsultationConfiguration[
                                                          i
                                                          ] &&
                                                          errors
                                                            .firstConsultationConfiguration[i]
                                                            .consultation_price &&
                                                          touched.firstConsultationConfiguration &&
                                                          touched
                                                            .firstConsultationConfiguration[
                                                          i
                                                          ] &&
                                                          errors
                                                            .firstConsultationConfiguration[i]
                                                            .consultation_price
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                      value={
                                                        this.state
                                                          .firstConsultationConfiguration[i]
                                                          .consultation_price
                                                      }
                                                    />

                                                    <ErrorMessage
                                                      name={`firstConsultationConfiguration[${i}].consultation_price`}
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                </td>
                                                <td>
                                                <div className="form-group">
                                                  <DatePicker
                                                    selected={
                                                      this.state
                                                          .firstConsultationConfiguration[i].datefrom
                                                        ? new Date(this.state
                                                          .firstConsultationConfiguration[i].datefrom)
                                                        : null
                                                    }
                                                    onChange={(date, dateString) => {
                                                      this.handlePriceInputDateChange(dateString, "datefrom", i);
                                                    }}
                                                    name="datefrom"
                                                    disabled={this.state.isBillingPractitioner !== 1}
                                                    disabledDate={(d) => !d || d.isAfter(this.state
                                                          .firstConsultationConfiguration[i].dateto)}
                                                    dateFormat="yyyy-MM-dd"
                                                    className={"form-control" +
                                                      (errors && errors.firstConsultationConfiguration &&
                                                        errors
                                                          .firstConsultationConfiguration[
                                                        i
                                                        ] &&
                                                        errors
                                                          .firstConsultationConfiguration[i]
                                                          .datefrom && touched &&
                                                        touched.firstConsultationConfiguration &&
                                                        touched
                                                          .firstConsultationConfiguration[
                                                        i
                                                        ] &&
                                                        touched
                                                          .firstConsultationConfiguration[i]
                                                          .datefrom
                                                        ? " is-invalid"
                                                        : "")
                                                    }
                                                    defaultValue={
                                                      this.state
                                                          .firstConsultationConfiguration[i]
                                                        .datefrom
                                                        ? moment(this.state
                                                          .firstConsultationConfiguration[i].datefrom)
                                                        : ""
                                                    }
                                                  />
                                                  <ErrorMessage
                                                    name={`firstConsultationConfiguration[${i}].datefrom`}
                                                    component="div"
                                                    className="invalid-feedback"
                                                  />
                                                </div>
                                              </td>
                                              <td>
                                                <div className="form-group">
                                                  <DatePicker
                                                    selected={
                                                      this.state
                                                          .firstConsultationConfiguration[i].dateto
                                                        ? new Date(this.state
                                                          .firstConsultationConfiguration[i].dateto)
                                                        : null
                                                    }
                                                    onChange={(date, dateString) => {
                                                      this.handlePriceInputDateChange(dateString, "dateto", i);
                                                    }}
                                                    name="dateto"
                                                    disabledDate={(d) => !d || d.isBefore(this.state
                                                          .firstConsultationConfiguration[i].datefrom)}
                                                    disabled={this.state.isBillingPractitioner !== 1}
                                                    dateFormat="yyyy-MM-dd"
                                                    className={"form-control" +
                                                      (errors && errors.firstConsultationConfiguration &&
                                                        errors
                                                          .firstConsultationConfiguration[
                                                        i
                                                        ] &&
                                                        errors
                                                          .firstConsultationConfiguration[i]
                                                          .dateto && touched &&
                                                        touched.firstConsultationConfiguration &&
                                                        touched
                                                          .firstConsultationConfiguration[
                                                        i
                                                        ] &&
                                                        touched
                                                          .firstConsultationConfiguration[i]
                                                          .dateto
                                                        ? " is-invalid"
                                                        : "")
                                                    }
                                                    defaultValue={
                                                      this.state
                                                          .firstConsultationConfiguration[i]
                                                        .dateto
                                                        ? moment(this.state
                                                          .firstConsultationConfiguration[i].dateto)
                                                        : ""
                                                    }
                                                  />

                                                  <ErrorMessage
                                                    name={`firstConsultationConfiguration[${i}].dateto`}
                                                    component="div"
                                                    className="invalid-feedback"
                                                  />
                                                </div>
                                              </td>
                                              </tr>
                                            </React.Fragment>
                                          
                                        );
                                      }
                                    )}

                                </tbody>
                                  </table>
                                  </div>
                                  </div>
                                  </div>
                        </div>

                      {/* {Certificates and Permits Section start} */}
                      <PermitsUpload
                        getPermitsProof={this.getPermitsProof}
                        getImageError={this.getImageError}
                        dataFromParent={this.state.inputList}
                        isLoading={this.props.loading}
                      />

                      {this.state.isBillingPractitioner === 1 && (
                      <div className={`form-box-shadow ${style.uploadMainWrapper}`}>
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="mb-3">
                              <h6 className={style.proofHeading}>Upload Practice Logo:</h6>
                              <small>
                                {`Allowed extensions are .jpg, .png, .svg and max limit size is 2MB.`}
                              </small>
                              <br />
                              <small>
                                {`Note: Please upload logo image of height ranging between 90px to 150px.`}
                              </small>
                              <br />
                              {/* <small>Allowed extentions are .jpg, .png, .svg</small> */}
                            </div>
                            <AddPracticeLogo
                              propsState={this.state}
                              getPicData={this.getLogoData}
                            />
                          </div>
                        </div>
                      </div>)}
        
                      <div className="row">
                        <div className="col-md-12">
                          {/* {JSON.stringify(errors)} */}
                        {Object.keys(errors).length > 0 && (
                              <div className="text-danger">
                                  Please fill all mandatory fields!
                              </div>
                          )}
                          {this.state.isLoading ? (
                            <div className={style.loadingWrapper}>
                              <img src={ttmLoader} alt="loader" className={style.loading} />
                            </div>
                          ) : (
                              <div>
                                {this.state.successMessage && (
                                  <p className={style.successMessage}>
                                    {this.state.successMessage}
                                  </p>
                                )}
                                {this.state.errorMessage && (
                                  <p className={style.errorMessage}>
                                    {this.state.errorMessage}
                                  </p>
                                )}
                              </div>
                            )}
                        </div>
                      </div>

                      <div className="row">
                        <div className={`col-lg-12 ${style.permitBtnWrapper}`}>
                          <div>
                            <Button type="submit" className="form-primary-btn">
                              Save
                          </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dropdownListData: state.dropdownList,
    fetchPracticeListData: state.practiceList,
    loading: state.practiceList.loading,
    disciplineListData: state.disciplineList,
    schemesData: state.schemes,
    pricegroupsListData: state.pricegroupsList
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDropdownList: () => dispatch(fetchDropdownList()),
    fetchPracticeList: () => dispatch(fetchPracticeList()),
    fetchDisciplineList: () => dispatch(fetchDisciplineList()),
    fetchMedSchemes: () => dispatch(fetchMedSchemes("")),
    fetchPricegroupsList: (discipline_code) => dispatch(fetchPricegroupsList(discipline_code)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PracticeComplience);
